import React from 'react'
import welcome from '../../assets/images/welcome.png'
import { useSelectorCustom } from '../../components/general/general-component/abstruct-component/useSelectorCustom'
import { AbstructLang } from '../../components/general/general-component/abstruct-component/AbstructLang';

function WelcomePage() {
    const { profileDetails, loadingProfileDetails } = useSelectorCustom()
    const { translate } = AbstructLang();
    return (
        <main>
            {console.log(profileDetails)}
            <div className="margin_main no-per-welcome" style={{ height: "70vh" }}>
                <img src={welcome} />
                <span>{translate('welcome')} {profileDetails?.name} {translate('your_cp')}</span>
            </div>
        </main>
    )
}

export default WelcomePage